import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import App from './App';

// Debug logging
console.log('React app initializing...');
console.log('window.gwSearch:', window.gwSearch);

// Wait for window.gwSearch to be available
const initApp = () => {
  if (!window.gwSearch) {
    console.log('Waiting for window.gwSearch...');
    setTimeout(initApp, 100);
    return;
  }

  console.log('window.gwSearch found, initializing app...');
  
  // first set the tab if there is a hash
  if (window.location.hash) {
    // first remove the hash
    const hash = window.location.hash.replace('#', '')
    if (hash === 'commercial' || hash === 'residential' || hash === 'sales') {
      window.gwSearch.activeTab = hash;
    }
  }

  const container = document.getElementById('goodwins-search-app');
  if (container !== null) {
    console.log('Rendering React app...');
    ReactDOM.render(<App />, container);
  } else {
    console.error('Could not find #goodwins-search-app element');
  }
};

// Start initialization
initApp();



// WEBPACK FOOTER //
// ./src/index.js